import moment from "moment";
import React from "react";

import { SearchQuery } from "shared/data/reducers/types/storage";

export default function DiffDays({
  dateDeparture,
  index,
  searchQuery,
}: {
  dateDeparture: string;
  index: number;
  searchQuery?: SearchQuery;
}) {
  if (!searchQuery) return null;

  const {
    departureDate,
    returnDate,
    flight_1_departureDate: flight1DepartureDate,
  } = searchQuery;
  const diffBaseDate = moment(
    index === 0
      ? departureDate || flight1DepartureDate
      : returnDate || searchQuery[`flight_${index + 1}_departureDate`]
  );
  const diffDays = moment(dateDeparture)
    .startOf("day")
    .diff(diffBaseDate, "days");

  return (
    <div className="flight-segment-times-moredays">
      {diffDays !== 0 && (
        <span>{diffDays > 0 ? `+${diffDays}d` : `${diffDays}d`}</span>
      )}
    </div>
  );
}
